<template>
  <div class="documents col-md-12" v-if="transportFilesList.length > 0">
    <div>
      <hint
        value="Прикрепите сканы документов в соответствующие для них разделы.<br>Максимально допустимый размер файла - 2 МБ."
        style="right: 15px"
      />
      <div v-if="transport.docError" class="form-fielderror" style="right: 40px">
        <label>!</label>
        <div class="form-fielderror-text">
          <div>Загрузите документы</div>
        </div>
      </div>
      <h4>Документы</h4>
    </div>
    <div class="panel-group documents-form-flex" :id="`visitor-${visitorIndex}-transport-${transportIndex}`">
      <template v-for="(documentObj, documentKey) in transportFilesList">
        <div
          :id="`visitor${visitorIndex}-transport${transportIndex}-document-block-${documentObj.document.short_name}`"
          :key="documentKey"
        >
          <uppy-uploader
            v-model="transport.files[documentObj.document.short_name]"
            :dashboard-show-condition="isNew || isDuplicate || isDraft || isEdit"
            :document-comment="documentObj.comment"
            :document-key="`visitor${visitorIndex}-transport${transportIndex}-${documentObj.document.short_name}`"
            :document-name="documentObj.document.name"
            :document-short-name="documentObj.document.short_name"
            :documents-show-condition="isView"
            :document-need-expire="documentObj.need_expire"
            :max-files-count="documentObj.document.max_file"
            :document-id="documentObj.document.id"
            entity-type="transport"
            :entity-id="transport.id"
            :get-uuid="getUUID"
            :has-errors="blockHasErrors(documentObj.document.short_name)"
            :key="`transport${transport.uuid}-${documentObj.document.short_name}`"
            :form="form"
            :owner-type="ownerType"
            :mime-types="$store.getters.documentValidators.find(validator => validator.id === documentObj.document.validator).mimeTypes"
            ref="uploader"
            @fileRemoved="fileRemoved"
            @change="forceUpdateForUppyUploader"
          >
            <template v-slot:left-side-modal>
              <div class="col-md-4 col-xs-4">
                <div class="row">
                  <div class="col-md-4 col-xs-4">
                    <span class="name-label">Тип</span>
                    <p>{{{'auto': 'Легковой', 'truck': 'Грузовой', 'bus': 'Автобус', 'bike': 'Велосипед / самокат', 'motorbike': 'Мотоцикл / мопед', 'special': 'Спецтехника', 'trailer': 'Прицеп / полуприцеп'}[transport.type]}}</p>
                  </div>
                  <div class="col-md-4 col-xs-4">
                    <span class="name-label">Номер / Прицеп</span>
                    <p>{{transport.number}} {{transport.trailer}}</p>
                  </div>
                  <div class="col-md-4 col-xs-4">
                    <span class="name-label">Марка / Модель</span>
                    <p>{{transport.mark}} {{transport.model}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-xs-6">
                    <span class="name-label">Цвет</span>
                    <p>{{transport.color}}</p>
                  </div>
                  <div class="col-md-6 col-xs-6">
                    <span class="name-label">Собственник</span>
                    <p>{{transport.owner}}</p>
                  </div>
                </div>
              </div>
            </template>
          </uppy-uploader>
          <div class="error-text" v-html="blockErrors(documentObj.document.short_name)"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import DocumentTypes from '@/common/enums/DocumentTypes'
import hasErrorsMixin from '@/common/mixins/hasErrorsMixin'
import transportInputMixin from '@/common/mixins/application-form/transportInputMixin'
import UppyUploader from '@/common/components/inputs/UppyUploader'
import visitorInputMixin from '@/common/mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'
import { TransportTypes } from '../../../../enums/TransportTypes';

export default {
  name: 'TransportDocumentsFormBlock',

  components: {
    Hint,
    UppyUploader
  },

  mixins: [
    hasErrorsMixin,
    transportInputMixin,
    visitorInputMixin,
    applicationFormMixin,
    applicationInputMixin
  ],

  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    transportDocuments: {
      type: [Object, Array],
      default: () => []
    }
  },

  data: () => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL
  }),

  updated() {
    this.$refs?.uploader?.forEach((uppy) => {
      uppy.$forceUpdate()
    })
  },

  computed: {
    ownerType() {
      return DocumentTypes.TRANSPORT
    },

    transportFilesErrors() {
      if (this.errors?.visitors && this.errors?.visitors[this.visitorIndex]?.transports[this.transportIndex]) {
        return this.errors?.visitors[this.visitorIndex]?.transports[this.transportIndex] ?? {}
      }

      return {}
    },

    transportFilesList() {
      const application = this.form.application
      const documents = []
      for (const document of this.transportDocuments) {
        if (![application.terminal_region_id, null].includes(document.region_id)) {
          continue
        }
        if (![this.transport.type, null].includes(document.transport_id)) {
          continue
        }
        if (!this.hasNumber(document.has_number)) {
          continue
        }
        documents.push(document)
      }

      return documents
    }
  },

  methods: {
    blockHasErrors(field) {
      return this.hasError(this.errors.visitors?.[this.visitorIndex]?.transports?.[this.transportIndex]?.files, field)
    },

    hasNumber(has_number) {
      if (has_number === null) {
        return true
      }
      if (has_number === 1) {
        return this.transport.number_missing === 0 || this.transport.number_missing === false
      }
      if (has_number === 0) {
        return this.transport.number_missing === 1 || this.transport.number_missing === true
      }
    },

    blockErrors(field) {
      return this.hasError(this.errors.visitors?.[this.visitorIndex]?.transports?.[this.transportIndex]?.files, field)?.[0]
    },

    /**
     * @param {UppyFile<UppyFileMeta, Null>} removedFile
     */
    fileRemoved(removedFile) {
      ApiClient.removeUploadedDocument({ uuid: removedFile.meta.uuid })
    },

    // TODO Analyze why the component does not register document changes in the UppyUploader without the “$forceUpdate” method and why it registers with the “$forceUpdate” method
    // TODO Remove the crutch based on the results of the analysis above
    forceUpdateForUppyUploader() {
      this.$forceUpdate()
    },

    getUUID(file) {
      return file.uuid
    }
  }
}
</script>
